export type Benchmark = {
    end: (message?: string) => number
}

export function bench(prefix: string): Benchmark {
    const startedAt = new Date()

    // eslint-disable-next-line no-console
    console.log(`${prefix}: ${startedAt.toISOString()}`)

    let lastDate = startedAt
    return {
        end: (message) => {
            const now = new Date()
            const total = now.getTime() - startedAt.getTime()
            const self = now.getTime() - lastDate.getTime()
            // eslint-disable-next-line no-console
            console.log(
                `${prefix}: (${now.toISOString()}): total: ${total}ms, self: ${self}ms - ${message}`
            )

            lastDate = now

            return total
        },
    }
}
